import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import StockCardReportActions from '../../Stores/StockCardReport/Actions';

const { Panel } = Collapse;

class StockCardReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initStockCard } = this.props;

    if (curSiteFlowId > 0) {
      initStockCard();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initStockCard } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initStockCard();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'stock_card_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

StockCardReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initStockCard: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

StockCardReportScreen.defaultProps = {
  intl: {},
  match: {},

  initStockCard: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initStockCard: () => dispatch(StockCardReportActions.stockCardReportInitStockCard())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(StockCardReportScreen));
